// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1vckd","header":"ClearentDisclaimer_header__ngsz3","inner":"ClearentDisclaimer_inner__1unqx"};